"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [// Whitespace is always a word boundary.
  " ", "\\n", "\\r", "\\t", // NO-BREAK SPACE.
  "\xA0", // \u06d4 - Urdu full stop
  "\u06D4", // \u061f - Arabic question mark
  "\u061F", // \u060C - Arabic comma
  "\u060C", // \u061B - Arabic semicolon
  "\u061B", " ", ".", ",", "'", "(", ")", "\"", "+", "-", ";", "!", "?", ":", "/", "»", "«", "‹", "›", "<", ">", "”", "“", "〝", "〞", "〟", "‟", "„"];
};

;